import { ActionType } from 'redux-promise-middleware';

export const pending = (action: string) => `${action}_${ActionType.Pending}`;
export const fulfilled = (action: string) => `${action}_${ActionType.Fulfilled}`;
export const rejected = (action: string) => `${action}_${ActionType.Rejected}`;
